export default __webpack_public_path__ + "static/summer_containers55-f7e4cd79bf1e3b963da805ccd8a340a6.webp";